module.exports = __webpack_public_path__ + "static/media/select.32ca6de4.svg";